module.exports = [
  "DSProvider",
  "DSHttpAdapterProvider",
  function(DSProvider, DSHttpAdapterProvider) {
    var applyAttrs = function(attrs, data) {
      if (attrs && !Array.isArray(data)) {
        for (var k in attrs) {
          data[k] = attrs[k];
        }
      }
    };

    var cacheTimeoutId;
    var cachePending = [];
    angular.extend(DSProvider.defaults, {
      basePath: API_URL,
      watchChanges: false,
      onConflict: "replace",
      strategy: "fallback",
      fallbackAdapters: ["cache", "http"],

      cache: function(config, data) {
        cachePending.push([config, data]);
        if (!cacheTimeoutId) {
          cacheTimeoutId = setTimeout(function() {
            cacheTimeoutId = undefined;
            cachePending.forEach(function(args) {
              cacheItem(args[0], args[1]);
            });
            cachePending = [];
          });
        }
      },

      beforeUpdate: function(config, data, cb) {
        if (config.adapter !== "http") {
          applyAttrs(config.attrs, data);
        }
        cb(null, data);
      },
      afterFindAll: function(config, data, cb) {
        if (!data) {
          // added to prevent errors in customized code
          cb(null, data);
          return;
        }
        data.forEach(applyAttrs.bind(this, config.attrs));
        // applyAttrs(config.attrs, data);
        var hasCachedData = data.length > 0;
        if (hasCachedData) {
          cb(null, data);
        }

        var adapter = config.adapter;
        if (!adapter) {
          if ((config.strategy || config.findAllStrategy) === "fallback") {
            adapter = (config.findFallbackAdapter ||
              config.fallbackAdapters)[0];
          } else {
            adapter = config.defaultAdapter;
          }
        }
        var previousAdapters = config.previousAdapters || [];
        if (adapter !== "cache") {
          var items = Array.isArray(data) ? data : [data];
          items.forEach(function(item) {
            DSProvider.defaults.cache(config, item);
          });
        } else if (previousAdapters.indexOf("http") === -1) {
          if (
            config.getFallbackRefresh &&
            !config.getFallbackRefresh(config, data)
          ) {
            return;
          }
          // previousAdapters.push('config');
          setTimeout(function() {
            var opts = Object.create(Object.getPrototypeOf(config));
            Object.getOwnPropertyNames(config).forEach(function(name) {
              opts[name] = config[name];
            });
            opts.strategy = "single";
            opts.adapter = "http";
            opts.bypassCache = true;
            opts.usePendingFindAll = true;

            var queryHash = DS.utils.toJson(config.params || {});
            delete DS.store[config.name].pendingQueries[queryHash];
            var findAll = config.findAll(opts.params || {}, opts);
            if (!hasCachedData) {
              findAll.then(cb.bind(this, null)).catch(cb);
            }
          });
        }
      },
      afterFind: afterFind,
      afterUpdate: afterUpdate
    });
    angular.extend(DSHttpAdapterProvider.defaults, {
      log: angular.noop
    });

    function afterFind(config, data, cb) {
      applyAttrs(config.attrs, data);
      cb(null, data);

      var adapter = config.adapter || config.defaultAdapter;
      var previousAdapters = config.previousAdapters || [];
      if (adapter !== "cache") {
        var items = Array.isArray(data) ? data : [data];
        items.forEach(function(item) {
          DSProvider.defaults.cache(config, item);
        });
      } else if (previousAdapters.indexOf("http") === -1) {
        if (
          config.getFallbackRefresh &&
          !config.getFallbackRefresh(config, data)
        ) {
          return;
        }
        setTimeout(function() {
          var opts = Object.create(config);
          opts.findStrategy = "single";
          opts.adapter = "http";
          opts.bypassCache = true;
          opts.usePendingFind = true;
          opts.attrs = config.attrs;
          config.find(data[config.idAttribute], opts);
        });
      }
    }

    function afterUpdate(config, data, cb) {
      applyAttrs(config.attrs, data);
      cb(null, data);

      var adapter = config.adapter || config.defaultAdapter;
      if (adapter !== "cache") {
        var items = Array.isArray(data) ? data : [data];
        items.forEach(function(item) {
          DSProvider.defaults.cache(config, item);
        });
      }
    }

    function cacheItem(config, item) {
      var cache = config.getAdapter("cache");
      var opts = {
        adapter: "cache",
        attrs: config.attrs,
        params: config.params,
        previousAdapters: [config.adapter || config.defaultAdapter].push(
          config.previousAdapters || []
        ),
        cacheResponse: false
      };

      var attrs = DS.utils.omit(
        item,
        config.omit.concat(config.relationFields || [])
      );
      var id = attrs[config.idAttribute];
      if (config.beforeCache) {
        var replace = config.beforeCache(id, attrs, opts);
        id = replace[0];
        attrs = replace[1];
        opts = replace[2];
      }
      var path = cache.getIdPath(config, opts, id);
      cache
        .PUT(path, attrs)
        .then(function() {
          console.log("Cached", config.name + ":" + attrs[config.idAttribute]);
        })
        .catch(function() {
          console.log(
            "Error caching",
            config.name + ":" + attrs[config.idAttribute]
          );
        });
    }
  }
];



// WEBPACK FOOTER //
// ./src/api/js-data/config.js